import {registerTemplateGraphNode} from "#template/template-node/register"
import {z} from "zod/v4-mini"
import {StringNode} from "#template/nodes/string/string-node"
import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"
import type {StringLike} from "#template/nodes/types"
import {stringLike} from "#template/nodes/string/fundamental"
import type {BuilderInlet} from "#template/runtime-graph/graph-builder"
import type {GraphBuilderScope} from "#template/runtime-graph/graph-builder-scope"
import type {NodeEvaluator} from "#template/node-evaluator"

export type RegexReplaceParameters = {
    input: StringLike
    regex: StringLike
    replace: StringLike
}

const regexReplaceDefinition: TemplateNodeDefinition<RegexReplaceParameters> = {
    nodeClass: "RegexReplace",
    validation: {
        parameters: z.object({
            input: stringLike,
            regex: stringLike,
            replace: stringLike,
        }),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class RegexReplace extends StringNode<RegexReplaceParameters> {
    public override get definition() {
        return regexReplaceDefinition
    }

    public override evaluate(scope: GraphBuilderScope, evaluator: NodeEvaluator): BuilderInlet<string | null> {
        const input = evaluator.evaluate(this.parameters.input)
        const regex = evaluator.evaluate(this.parameters.regex)
        const replace = evaluator.evaluate(this.parameters.replace)
        return scope.pureLambda(
            scope.tuple(input, regex, replace),
            ([input, regex, replace]) => {
                if (input === null || regex === null || replace === null) return null
                return input.replace(new RegExp(regex), replace)
            },
            "regexpReplace",
        )
    }
}
